import React from "react";
import "./advertisement.scss";
import add from "../../../../src/assets/images/add_img.png";
import instaIcon from "../../../assets/images/instaIcon.svg";
import whatsappIcon from "../../../assets/images/whatsapp_icon.svg";
import enquiryIcon from "../../../assets/images/enquiryIcon.svg";
import fbIcon from "../../../assets/images/fb_icon.svg";
import directionIcon from "../../../assets/images/directionIcon.svg";

const Advertisement = ({
  src,
  action,
  poster,
  icon,
  title,
  iconUpdated = null,
}) => {
  // Helper function to get the correct icon image
  const getIconImage = (icon) => {
    const iconMap = {
      whatsapp: whatsappIcon,
      instagram: instaIcon,
      enquiry: enquiryIcon,
      facebook: fbIcon,
      direction: directionIcon,
    };
    // const title = {
    //     whatsapp: whatsappIcon,
    //     instagram: instaIcon,
    //     enquiry: 'Enquiry',
    //     facebook: 'Contact on facebook',
    //     direction: directionIcon,
    // }

    return iconMap[icon] || null; // Return the image or null if not found
  };

  const iconImage = getIconImage(icon);

  let advertisementAction;
  switch (action) {
    case "enquiry":
      advertisementAction = "enq";
      break;
    case "whatsapp":
      advertisementAction = "wp";
      break;
    case "instagram":
      advertisementAction = "inst";
      break;
    case "phone":
      advertisementAction = "phn";
      break;
    case "direction":
      advertisementAction = "dir";
      break;
    default:
      break;
  }

  return (
    <div className="add_display red_shadow">
      <figure>
        <img src={poster} alt="" className="img_full cover" />
      </figure>
      <div
        className={`ad_bottom ${advertisementAction}`}
        style={{ background: "rgb(7, 168, 132)" }}
      >
        <span>
          {iconUpdated ? (
            <span className="icon_updated">
              <img src={iconUpdated} alt="icon" className="img_full contain" />
            </span>
          ) : (
            <span className="icon">
              {iconImage && (
                <img src={iconImage} alt="icon" className="img_full contain" />
              )}
            </span>
          )}

          <span style={{ textTransform: "capitalize" }}>{title || ""}</span>
        </span>
        <a href="#" style={{ pointerEvents: "none" }}>
          View Details <span></span>
        </a>
      </div>
    </div>
  );
};

export default Advertisement;
